import { z } from 'zod'
import type { NoContext } from '~/services/api/contracts/NoContext'
import { UpdateStoreMenuOrderRequestSchema } from '~/services/api/generated'
import { fieldNormalizer } from '~/services/api/contracts/fieldNormalizer'

const schema = UpdateStoreMenuOrderRequestSchema.strict()

const normalize = fieldNormalizer({
  lists: [{ key: 'menus', spec: { int: ['menu_id', 'order'] } }]
})

export const MenuUpdateStoreMenuOrder = (_context: NoContext): z.ZodType<z.output<typeof schema>> =>
  z.preprocess(normalize, schema).superRefine((value, issues) => {
    const seenMenuIds = new Map<number, number>()
    const seenOrders = new Map<number, number>()
    value.menus.forEach((menu) => {
      seenMenuIds.set(menu.menu_id, (seenMenuIds.get(menu.menu_id) ?? 0) + 1)
      seenOrders.set(menu.order, (seenOrders.get(menu.order) ?? 0) + 1)
    })

    value.menus.forEach((menu, index) => {
      if ((seenMenuIds.get(menu.menu_id) ?? 0) > 1) {
        issues.addIssue({
          code: 'custom',
          message: 'Each menu can only be included once',
          path: ['menus', index, 'menu_id']
        })
      }
      if ((seenOrders.get(menu.order) ?? 0) > 1) {
        issues.addIssue({
          code: 'custom',
          message: 'Each menu order position must be unique',
          path: ['menus', index, 'order']
        })
      }
    })
  })
